module.exports = __webpack_public_path__ + "img/star_punter-icon.26033876.svg";